@if (!isReplaying) {
  <div>
    <button
      [disabled]="!isReplayable"
      [class.disabled]="!isReplayable"
      id="buttonStartReplay"
      class="headerButton"
      title="Start replay"
      (click)="startReplay.emit()"
    >
      <span class="material-icons-outlined materialIconButton">
        play_arrow
      </span>
      <div class="button-label">Replay</div>
    </button>

    <button
      id="buttonImport"
      class="headerButton"
      title="Import story from file"
      onclick="document.getElementById('import').click();"
    >
      <span class="material-icons-outlined materialIconButton">
        file_upload
      </span>
      <div class="button-label">Import file</div>
    </button>

    <button
      id="buttonUrlImport"
      class="headerButton"
      title="Import story from URL"
      (click)="openImportFromUrlDialog.emit()"
    >
      <span class="material-icons-outlined materialIconButton">
        cloud_upload
      </span>
      <div class="button-label">Import URL</div>
    </button>

    <input
      type="file"
      accept=".dst, .svg, .egn, .svg"
      style="display: none"
      id="import"
      onclick="this.value=null;"
      (change)="import.emit()"
    />
    <button
      [disabled]="!hasDomainStory && !hasTitle"
      [class.disabled]="!hasDomainStory && !hasTitle"
      class="headerButton"
      [class.dirty]="isDirty"
      id="export"
      title="Export story as .egn, .svg or .png file"
      (click)="openDownloadDialog.emit()"
    >
      <span class="material-icons-outlined materialIconButton">
        file_download
      </span>
      <div class="button-label">Export</div>
    </button>
    <button
      [disabled]="!hasDomainStory"
      [class.disabled]="!hasDomainStory"
      class="headerButton"
      title="Label Dictionary"
      (click)="openLabelDictionary.emit()"
    >
      <span class="material-icons materialIconButton" title="Label Dictionary">
        spellcheck
      </span>
      <div class="button-label">Dictionary</div>
    </button>

    <button
      class="headerButton"
      title="Create a new domain story"
      (click)="newStory.emit()"
    >
      <span class="material-icons-outlined materialIconButton"> note_add </span>
      <div class="button-label">New story</div>
    </button>

    <button class="headerButton" title="Settings" (click)="openSettings.emit()">
      <span
        class="material-icons-outlined materialIconButton"
        title="Change Icons and Settings"
      >
        settings
      </span>
      <div class="button-label">Settings</div>
    </button>

    <button
      class="headerButton"
      title="Show keyboard shortcuts"
      (click)="showKeyboardShortCuts.emit()"
    >
      <span class="material-icons-outlined materialIconButton"> keyboard </span>
      <div class="button-label">Shortcuts</div>
    </button>
  </div>
}
@if (isReplaying) {
  <div class="replaying">
    <button
      class="headerButton"
      title="Previous sentence"
      (click)="previousSentence.emit()"
    >
      <span class="material-icons-outlined materialIconButton">
        skip_previous
      </span>
      <div class="button-label">Prev.</div>
    </button>
    <button
      class="headerButton"
      title="Next sentence"
      (click)="nextSentence.emit()"
    >
      <span class="material-icons-outlined materialIconButton">
        skip_next
      </span>
      <div class="button-label">Next</div>
    </button>
    <button
      class="headerButton"
      title="Stop replay"
      (click)="stopReplay.emit()"
    >
      <span class="material-icons-outlined materialIconButton"> stop </span>
      <div class="button-label">Stop</div>
    </button>
    <div class="sentences">Sentence: {{ sentenceDescription$ | async }}</div>
  </div>
}
